/* eslint-disable prefer-promise-reject-errors */
// src/utils/axios.js
import axios from 'axios';
import { getCancelTokenSource, removeCancelTokenSource, generateRequestKey } from './cancelToken';
import { checkCacheReset, checkForCacheIssue } from './axiosCacheReset';

const axiosInstance = axios.create({ baseURL: 'Api/' });

axiosInstance.interceptors.request.use((config) => {
  checkCacheReset(config);
  const requestKey = generateRequestKey(config);
  const cancelTokenSource = getCancelTokenSource(requestKey);
  config.cancelToken = cancelTokenSource.token;
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    //console.log('Response', response.request.responseURL);
    checkForCacheIssue(response);
    const requestKey = generateRequestKey(response.config);
    removeCancelTokenSource(requestKey);
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      console.log('Request canceled, duplicate call', error);
      const canceledRequestUrl = `${error?.config?.baseURL ?? ''}${error?.config?.url ?? ''}`;
      return Promise.reject(`Request canceled, duplicate call${canceledRequestUrl ? ` ${canceledRequestUrl}` : ''}`);
    }
    if (error.response?.status === 401) {
      window.location.href = `/auth/login?returnUrl=${window.location.href}`;
      return Promise.reject('401 Unauthorized');
    }
    if (error.response?.status === 403) {
      console.error('403 Forbidden', window.location.href);
      return Promise.reject('403 Forbidden');
    }
    if (error.code === "ECONNABORTED") return Promise.reject('Timeout');
    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);

export default axiosInstance;
